import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { HttpService } from './http.service';
import { LoggerService } from '../../infra/logger/logger.service';

/**
 * This service wraps angular HttpClient.
 * All the http request will be use this wrapper.
 */
export class MicroserviceHttpService extends HttpService {
  constructor(_http: HttpClient, service: keyof typeof environment.services, _logger: LoggerService) {
    super(_http);

    if (!environment.services || !environment.services[service]) {
      _logger.error(`Service ${service} is not defined in the environment`);
      return;
    }
    this._baseUrl = `${environment.services[service].base_url}/${environment.services[service].api_version}`;
    this._betaBaseUrl = `${environment.services[service].base_url}/${environment.services[service].api_beta_version}`;
  }
}
